<script>
import {supabase} from "./supabaseClient"
import { fade, fly } from 'svelte/transition';
import router from 'page'

import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

let email;
let errorMessage ='';
let submitStatus = -1;

const handleResetPassword = async () => {

  const { data, error } = await supabase
  .auth
  .resetPasswordForEmail(email,{redirectTo:  location.protocol + '//' + location.host + `/ResetPassword?email=`+email})

  // let { data, error } = await supabase.auth.api.resetPasswordForEmail(email,{redirectTo:  location.protocol + '//' + location.host + `/ResetPassword?email=`+email})

  if (error) {
    submitStatus = 1
    errorMessage = error.message
    console.log(error)
  } else {
    submitStatus = 0
}
}
</script>
<StandardHeader />
<div style="display:flex; flex-direction: column; height: 100%; margin-left: auto; margin-right: auto; min-width:300px; max-width:300px; margin-top: auto;margin-top: 10%">
<div><b>Request Password Reset</b></div>
{#if submitStatus == -1 || submitStatus == 1}
  <form on:submit|preventDefault={handleResetPassword} id="RequestPasswordReset">

    <div class="space-y-4">
      <input
        type="email"
        placeholder="Email"
        bind:value={email}
        class="input input-bordered w-full"
      />
    
      <div class="flex justify-end">
        <button type="submit" class="btn bg-[var(--aqua)] text-white hover:opacity-90">
          Request Password Reset
        </button>
      </div>
    </div>
    
    <!-- <div><input placeholder="Email" bind:value={email} style="width:100%"/> </div>
    <div><button class="primary" style="float:right" type="submit">Request Password Reset </button> </div> -->
  </form>
{/if}
{#if submitStatus == 0}
  <div style="color:green" in:fade="{{ y: 200, duration: 2000 }}">Please check your email for the link to reset your password.</div>
{:else if submitStatus == 1}
    <div style="color:red" in:fade="{{ y: 200, duration: 2000 }}">{errorMessage}</div>
{/if}
</div>

<StandardFooter />
